import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Heading from "./Heading";
import Footer from "./Footer";
import { deleteAccount, restoreSession, useProfileAuthStore, useProfileStore, } from "./store/ProfileStore";
import { Link, useNavigate } from "react-router-dom";
import { Button, Card, CardActions, CardContent, Container, FormControlLabel, LinearProgress, Stack, Switch, TextField, ThemeProvider, Typography, } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import getTheme from "./Theme";
import { useEffect, useState } from "react";
import { doLogoutRedirect } from "./Auth/AuthUtils";
import { InvalidInputError, validateDisplayName, validateEmailAddress, } from "./util/validateInput";
import { getUploadURL, getContentURL, getSiteBaseURL, getChannelViewBaseURL, } from "./ContentAPI";
import { updateTypesBestEffort, uploadImageDataDirect, } from "./util/ImageUtils";
import { ContentCardStacks } from "./components/ContentCardStacks";
import { ContentCard } from "./components/ContentCard";
import { getChannelData } from "./store/ChannelStore";
import { FeedCardButton } from "./components/FeedCardButton";
import React from "react";
import { authUrl, useCacheBusterStore } from "./util/UrlUtils";
import { TopButtonMenu } from "./components/TopButtonMenu";
import { useLogger } from "./logger";
import AgeVerificationStatusCard from "./components/AgeVerificationStatusCard";
const LOGPREFIX = "ProfileSettings: ";
export var ClientDetailCode;
(function (ClientDetailCode) {
    ClientDetailCode[ClientDetailCode["SUCCESS"] = 1000] = "SUCCESS";
    ClientDetailCode[ClientDetailCode["MISSING_AUTH_HEADER"] = 4001] = "MISSING_AUTH_HEADER";
    ClientDetailCode[ClientDetailCode["INVALID_AUTH_HEADER"] = 4002] = "INVALID_AUTH_HEADER";
    ClientDetailCode[ClientDetailCode["MISSING_EVENT_BODY"] = 4003] = "MISSING_EVENT_BODY";
    ClientDetailCode[ClientDetailCode["WRONG_USER_ID_AUTH"] = 4004] = "WRONG_USER_ID_AUTH";
    ClientDetailCode[ClientDetailCode["WRONG_USER_ID_OPERATION"] = 4005] = "WRONG_USER_ID_OPERATION";
    ClientDetailCode[ClientDetailCode["INVALID_DISPLAY_NAME"] = 4006] = "INVALID_DISPLAY_NAME";
    ClientDetailCode[ClientDetailCode["VERIFY_FAILED_CODE_MISMATCH"] = 5001] = "VERIFY_FAILED_CODE_MISMATCH";
    ClientDetailCode[ClientDetailCode["VERIFY_FAILED_CODE_EXPIRED"] = 5002] = "VERIFY_FAILED_CODE_EXPIRED";
    ClientDetailCode[ClientDetailCode["VERIFY_FAILED_INVALID_CODE_OR_EMAIL"] = 5003] = "VERIFY_FAILED_INVALID_CODE_OR_EMAIL";
    ClientDetailCode[ClientDetailCode["VERIFY_FAILED_LIMIT_EXCEEDED"] = 5004] = "VERIFY_FAILED_LIMIT_EXCEEDED";
    ClientDetailCode[ClientDetailCode["VERIFY_FAILED_NOT_AUTHORIZED"] = 5005] = "VERIFY_FAILED_NOT_AUTHORIZED";
    ClientDetailCode[ClientDetailCode["VERIFY_FAILED_PASSWORD_RESET_REQUIRED"] = 5006] = "VERIFY_FAILED_PASSWORD_RESET_REQUIRED";
    ClientDetailCode[ClientDetailCode["VERIFY_FAILED_TOO_MANY_REQUESTS"] = 5007] = "VERIFY_FAILED_TOO_MANY_REQUESTS";
    ClientDetailCode[ClientDetailCode["VERIFY_FAILED_ALIAS_EXISTS"] = 5008] = "VERIFY_FAILED_ALIAS_EXISTS";
    ClientDetailCode[ClientDetailCode["RESEND_FAILED_LIMIT_EXCEEDED"] = 6001] = "RESEND_FAILED_LIMIT_EXCEEDED";
    ClientDetailCode[ClientDetailCode["RESEND_FAILED_NOT_AUTHORIZED"] = 6002] = "RESEND_FAILED_NOT_AUTHORIZED";
    ClientDetailCode[ClientDetailCode["RESEND_FAILED_PASSWORD_RESET_REQUIRED"] = 6003] = "RESEND_FAILED_PASSWORD_RESET_REQUIRED";
    ClientDetailCode[ClientDetailCode["RESEND_FAILED_TOO_MANY_REQUESTS"] = 6004] = "RESEND_FAILED_TOO_MANY_REQUESTS";
    ClientDetailCode[ClientDetailCode["UNEXPECTED_ERROR"] = 7001] = "UNEXPECTED_ERROR";
})(ClientDetailCode || (ClientDetailCode = {}));
const signOutButton = (_jsx(Button, Object.assign({ variant: "outlined", onClick: () => {
        setTimeout(() => {
            doLogoutRedirect();
        }, 100);
    }, sx: { margin: "10px" } }, { children: "SIGN OUT" })));
export function ProfileSettings() {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    const cacheBusterStore = useCacheBusterStore((state) => state);
    const [displayName, setDisplayName] = useState("");
    const [displayNameModified, setDisplayNameModified] = useState(false);
    const [displayNameHelperText, setDisplayNameHelperText] = useState("");
    const [displayNameSaving, setDisplayNameSaving] = useState(false);
    const [displayNameSavedOk, setDisplayNameSavedOk] = useState(false);
    const [displayNameSaveError, setDisplayNameSaveError] = useState("");
    const [email1, setEmail1] = useState("");
    const [email1Modified, setEmail1Modified] = useState(false);
    const [email1HelperText, setEmail1HelperText] = useState("");
    const [email2, setEmail2] = useState("");
    const [email2Modified, setEmail2Modified] = useState(false);
    const [emailSaving, setEmailSaving] = useState(false);
    const [emailSavedOk, setEmailSavedOk] = useState(false);
    const [emailSaveError, setEmailSaveError] = useState("");
    const [code, setCode] = useState("");
    const [codeSaving, setCodeSaving] = useState(false);
    const [codeSavedOk, setCodeSavedOk] = useState(false);
    const [codeSaveError, setCodeSaveError] = useState("");
    const [codeSending, setCodeSending] = useState(false);
    const [codeSendOk, setCodeSendOk] = useState(false);
    const [codeSendError, setCodeSendError] = useState("");
    const [imageSaving, setImageSaving] = useState(false);
    const [imageSaveError, setImageSaveError] = useState("");
    const [previewImageUrl, setPreviewImageUrl] = useState(null);
    const [loading, setLoading] = useState(false);
    const [deleteAccountClicked, setDeleteAccountClicked] = useState(false);
    const [feedData, setFeedData] = useState();
    // Notifications state
    const [emailNotifications, setEmailNotifications] = useState(true);
    const [notificationsModified, setNotificationsModified] = useState(false);
    const [notificationsSaving, setNotificationsSaving] = useState(false);
    const [notificationsSavedOk, setNotificationsSavedOk] = useState(false);
    const [notificationsSaveError, setNotificationsSaveError] = useState("");
    const auth = useProfileAuthStore((state) => state);
    const profile = useProfileStore((state) => state);
    const logger = useLogger((state) => state);
    const navigate = useNavigate();
    useEffect(() => {
        const retVal = () => { };
        if (!auth || !auth.isSignedIn() || !auth.userId) {
            return retVal;
        }
        if (!feedData) {
            getChannelData(auth.userId, auth.userId, auth, cacheBusterStore, logger)
                .then((feedData) => {
                logger.log(LOGPREFIX + "Setting Feed Data: " + JSON.stringify(feedData));
                setFeedData(feedData);
            })
                .catch((err) => {
                logger.error(LOGPREFIX + "Feed Data Load Failed: " + err);
            });
        }
        return retVal;
    }, [setFeedData, auth.isSignedIn()]);
    useEffect(() => {
        logger.log(LOGPREFIX + "useEffect-auth");
        if (!auth.isSignedIn() || !auth.userId) {
            logger.log(LOGPREFIX + "User NOT logged in - Attempting restore...");
            if (!restoreSession(auth, logger)) {
                logger.log(LOGPREFIX + "User NOT logged in - Restore failed. Navigating...");
                navigate("/Welcome", { replace: true });
            }
            else {
                logger.log(LOGPREFIX + "Restored OK");
            }
        }
        logger.log(LOGPREFIX + "useEffect-auth - done");
        return () => { };
    }, [auth.isSignedIn()]);
    useEffect(() => {
        logger.log(LOGPREFIX + "useEffect-profile: start");
        if (auth.isSignedIn()) {
            if (auth.userId &&
                !profile.ok &&
                !profile.done &&
                !profile.error &&
                !profile.start &&
                !loading) {
                logger.log(LOGPREFIX + "useEffect-profile: Start profile load...");
                setLoading(true);
                profile.loadProfile(auth.userId, auth, cacheBusterStore, logger);
            }
            if (profile.done) {
                logger.log(LOGPREFIX + "useEffect-profile: Done - set not loading");
                setLoading(false);
            }
        }
        logger.log(LOGPREFIX + "useEffect-profile: done");
        return () => { };
    }, [profile, auth.isSignedIn()]);
    // Initialize notifications state from profile data
    useEffect(() => {
        var _a;
        if ((_a = profile.profile) === null || _a === void 0 ? void 0 : _a.subscriptions) {
            setEmailNotifications(profile.profile.subscriptions.emailNotifications);
            setNotificationsModified(false); // Reset modified flag when loading from profile
        }
    }, [(_a = profile.profile) === null || _a === void 0 ? void 0 : _a.subscriptions]);
    const doDeleteAccount = () => {
        logger.log(LOGPREFIX + "deleteAccount");
        deleteAccount({
            okCallback: () => {
                logger.log(LOGPREFIX + "doDeleteAccount.okCallback");
                doLogoutRedirect();
            },
            errorCallback: (clientDetailCode, errorMessage) => {
                logger.error(LOGPREFIX +
                    "doDeleteAccount.errorCallback: " +
                    clientDetailCode +
                    " " +
                    errorMessage);
                // TODO
                setDeleteAccountClicked(false);
            },
        }, auth, cacheBusterStore, logger);
    };
    const clickedDeleteAccount = () => {
        logger.log(LOGPREFIX + "clickedDeleteAccount");
        setDeleteAccountClicked(true);
    };
    const publicViewButton = (_jsx(Button, Object.assign({ href: getSiteBaseURL() + "ProfileView?userId=" + auth.userId, target: "_blank", variant: "contained", sx: { margin: "10px", marginTop: "15px" } }, { children: "Switch to Public View" })));
    const deleteAccountButton = (_jsx(Button, Object.assign({ variant: "outlined", onClick: () => {
            clickedDeleteAccount();
        }, sx: { margin: "10px" }, color: "error" }, { children: "DELETE ACCOUNT" })));
    const manageConsentButton = (_jsx("a", Object.assign({ href: "#", className: "termly-display-preferences" }, { children: _jsx(Typography, Object.assign({ variant: "body1" }, { children: "Consent Preferences" })) })));
    const dsarButton = (_jsx(Link, Object.assign({ to: "https://app.termly.io/notify/27991f50-d1d3-4aa9-a83a-41a121bc371c", target: "_blank" }, { children: _jsx(Typography, Object.assign({ variant: "body1" }, { children: "Data Subject Access Request (DSAR)" })) })));
    const validateUserNameAndUpdateHelpText = (input) => {
        logger.log(LOGPREFIX + "validateUserNameAndUpdateHelpText: " + input);
        try {
            validateDisplayName(input);
        }
        catch (error) {
            logger.log(LOGPREFIX + "INVALID DISPLAY NAME: " + error);
            if (error instanceof InvalidInputError) {
                setDisplayNameHelperText(error.message);
            }
            return false;
        }
        setDisplayNameHelperText("");
        return true;
    };
    const validateEmailNoUpdate = (email) => {
        logger.log(LOGPREFIX + "validateEmailNoUpdate: " + email);
        try {
            validateEmailAddress(email);
        }
        catch (error) {
            logger.log(LOGPREFIX + "INVALID EMAIL: " + error);
            return false;
        }
        return true;
    };
    const validateEmailAndUpdateHelpText = (email) => {
        logger.log(LOGPREFIX + "validateEmailAndUpdateHelpText: " + email);
        try {
            validateEmailAddress(email);
        }
        catch (error) {
            if (error instanceof InvalidInputError) {
                setEmail1HelperText(error.message);
            }
            logger.log(LOGPREFIX + "INVALID EMAIL: " + error);
            return false;
        }
        setEmail1HelperText("");
        return true;
    };
    const handleImageUpload = (event) => {
        var _a;
        const file = (_a = event.target.files) === null || _a === void 0 ? void 0 : _a[0];
        if (!file)
            return;
        if (!auth.isSignedIn() || !auth.userId || !auth.bearer) {
            setImageSaveError("User is not signed in.");
            return;
        }
        setImageSaving(true);
        setImageSaveError("");
        // Show preview immediately
        const previewUrl = URL.createObjectURL(file);
        setPreviewImageUrl(previewUrl);
        getUploadURL((ok, status, response) => {
            if (!ok || !(response === null || response === void 0 ? void 0 : response.url)) {
                setImageSaving(false);
                setImageSaveError("Failed to get upload URL: " + ((response === null || response === void 0 ? void 0 : response.error) || "Unknown error"));
                return;
            }
            if (response.bearer && response.sequence) {
                auth.setBearerAndSequence(response.bearer, response.sequence, logger);
            }
            uploadImageDataDirect(response.url, file, () => {
                updateTypesBestEffort(auth, "u", "profileImage_temp", cacheBusterStore, logger);
                cacheBusterStore.incrementCacheBuster();
                // Poll for processed image, then reload page
                pollForImageThenReload();
            }, (code, error) => {
                setImageSaving(false);
                setImageSaveError("Upload failed: " + error);
            }, cacheBusterStore, logger);
        }, auth.userId, "profileImage_temp", "u", "jpg", auth.bearer, auth.sequence, cacheBusterStore);
    };
    const pollForImageThenReload = () => {
        const startTime = Date.now();
        // First, get the current image data to compare against
        const originalUrl = authUrl(getContentURL() + "/u/" + auth.userId + "/profileImage_512.jpg", cacheBusterStore, auth);
        fetch(originalUrl)
            .then((response) => response.arrayBuffer())
            .then((originalData) => {
            const originalSize = originalData.byteLength;
            const checkForChanges = () => {
                // Check if we've been polling for more than 15 seconds
                if (Date.now() - startTime > 15000) {
                    cacheBusterStore.incrementCacheBuster();
                    setImageSaving(false);
                    alert("Your profile image has been updated, but the old image may remain visible for up to 24 hours.");
                    return;
                }
                // Increment cache buster to get fresh image
                cacheBusterStore.incrementCacheBuster();
                const newUrl = authUrl(getContentURL() + "/u/" + auth.userId + "/profileImage_512.jpg", cacheBusterStore, auth);
                fetch(newUrl)
                    .then((response) => response.arrayBuffer())
                    .then((newData) => {
                    const newSize = newData.byteLength;
                    if (newSize !== originalSize) {
                        // Image content has changed, processing is complete
                        setTimeout(() => {
                            cacheBusterStore.incrementCacheBuster();
                            window.location.reload();
                        }, 500);
                    }
                    else {
                        // Image hasn't changed yet, try again in 2 seconds
                        setTimeout(checkForChanges, 2000);
                    }
                })
                    .catch(() => {
                    // Error loading, try again in 2 seconds
                    setTimeout(checkForChanges, 2000);
                });
            };
            // Start checking for changes after a brief delay
            setTimeout(checkForChanges, 1000);
        })
            .catch(() => {
            // If original image fails to load, fall back to simple polling
            const checkForProcessedImage = () => {
                // Check timeout for fallback too
                if (Date.now() - startTime > 15000) {
                    setImageSaving(false);
                    alert("Your profile image has been updated, but the old image may remain visible for up to 24 hours.");
                    return;
                }
                cacheBusterStore.incrementCacheBuster();
                const processedUrl = authUrl(getContentURL() + "/u/" + auth.userId + "/profileImage_512.jpg", cacheBusterStore, auth) +
                    "&t=" +
                    Date.now();
                fetch(processedUrl)
                    .then(() => {
                    setTimeout(() => {
                        window.location.reload();
                    }, 500);
                })
                    .catch(() => {
                    setTimeout(checkForProcessedImage, 2000);
                });
            };
            setTimeout(checkForProcessedImage, 1000);
        });
    };
    const saveNotifications = () => {
        logger.log(LOGPREFIX + "saveNotifications");
        if (!auth.isSignedIn() || !auth.userId || !auth.bearer) {
            setNotificationsSaving(false);
            setNotificationsSavedOk(false);
            setNotificationsSaveError("User is not signed in.");
            return;
        }
        const subscriptions = {
            emailNotifications: emailNotifications,
        };
        setNotificationsSaving(true);
        setNotificationsSavedOk(false);
        setNotificationsSaveError("");
        profile.saveProfile(auth, {
            okCallback: (clientDetailCode) => {
                logger.log(LOGPREFIX + "saveNotifications-okCallback: " + clientDetailCode);
                setNotificationsSaving(false);
                setNotificationsSavedOk(true);
                setNotificationsModified(false); // Reset modified flag after successful save
                setTimeout(() => {
                    setNotificationsSavedOk(false);
                }, 2500);
            },
            errorCallback: (clientDetailCode, errorMessage) => {
                logger.log(LOGPREFIX +
                    "saveNotifications-errorCallback: " +
                    clientDetailCode +
                    " " +
                    errorMessage);
                setNotificationsSaving(false);
                setNotificationsSavedOk(false);
                setNotificationsSaveError(errorMessage + " (" + clientDetailCode + ")");
            },
        }, undefined, // displayName
        undefined, // email
        undefined, // code
        undefined, // termsAccepted
        cacheBusterStore, logger, subscriptions);
    };
    const cardsList = [];
    if (auth.isSignedIn() && !loading) {
        // Verify Code Card
        const verifyCardContent = (_jsxs(Stack, Object.assign({ spacing: 1, alignItems: "center", sx: { textAlign: "center" } }, { children: [_jsxs(Typography, Object.assign({ variant: "body2", gutterBottom: true }, { children: ["You have been sent a verification code via email.", _jsx("br", {}), "Enter the code.", _jsx("br", {})] })), _jsx(TextField, { id: "code", variant: "outlined", label: "Verification Code", size: "small", sx: { width: "300px" }, onChange: (event) => {
                        setCode(event.target.value);
                        setCodeSaveError("");
                        setCodeSendError("");
                    }, disabled: codeSending }), (codeSending || codeSaving) && (_jsx(LinearProgress, { sx: { width: "100%" } })), codeSendOk && (_jsx(Card, Object.assign({ elevation: 0, sx: { backgroundColor: "#EEFFEE", padding: "4", width: "100%" }, color: "text.error" }, { children: _jsxs(CardContent, { children: [_jsx(Typography, Object.assign({ variant: "h6", component: "div", color: "EEFFEE", gutterBottom: true }, { children: "CODE SENT" })), _jsx(Typography, Object.assign({ variant: "body2", color: "black" }, { children: "Verification code has been sent to your email." }))] }, "code.sent.ok.card.content") }), "code.sent.ok.card")), codeSavedOk && (_jsx(Card, Object.assign({ elevation: 0, sx: { backgroundColor: "#EEFFEE", padding: "4", width: "100%" }, color: "text.error" }, { children: _jsxs(CardContent, { children: [_jsx(Typography, Object.assign({ variant: "h6", component: "div", color: "EEFFEE", gutterBottom: true }, { children: "CODE VERIFIED" })), _jsx(Typography, Object.assign({ variant: "body2", color: "black" }, { children: "Code has been verified." }))] }, "code.saved.ok.card.content") }), "code.saved.ok.card")), codeSendError && (_jsx(Card, Object.assign({ elevation: 0, sx: { backgroundColor: "#FFEEEE", width: "100%" }, color: "text.error" }, { children: _jsxs(CardContent, { children: [_jsx(Typography, Object.assign({ variant: "h6", component: "div", color: "error", gutterBottom: true }, { children: "FAILED TO SEND CODE" })), _jsx(Typography, Object.assign({ variant: "body2" }, { children: codeSendError }))] }, "code.sent.error.content") }), "code.sent.saving.error")), codeSaveError && (_jsx(Card, Object.assign({ elevation: 0, sx: { backgroundColor: "#FFEEEE", width: "100%" }, color: "text.error" }, { children: _jsxs(CardContent, { children: [_jsx(Typography, Object.assign({ variant: "h6", component: "div", color: "error", gutterBottom: true }, { children: "FAILED TO VERIFY CODE" })), _jsx(Typography, Object.assign({ variant: "body2" }, { children: codeSaveError }))] }, "code.saved.error.content") }), "code.saved.saving.error"))] })));
        const verifyCardActions = codeSending || codeSaving ? undefined : (_jsxs(CardActions, Object.assign({ sx: { display: "flex", justifyContent: "center" } }, { children: [_jsx(Button, Object.assign({ variant: "contained", disabled: !code, onClick: () => {
                        setCodeSaving(true);
                        profile.saveProfile(auth, {
                            okCallback: (clientDetailCode) => {
                                logger.log(LOGPREFIX + "Code save OK - " + clientDetailCode);
                                setCodeSavedOk(true);
                                setCodeSaving(false);
                                setTimeout(() => {
                                    setCodeSavedOk(false);
                                }, 2500);
                            },
                            errorCallback: (clientDetailCode, errorMessage) => {
                                setCodeSavedOk(false);
                                setCodeSaving(false);
                                setCodeSaveError(errorMessage + " (" + clientDetailCode + ")");
                            },
                        }, undefined, undefined, code, undefined, cacheBusterStore, logger);
                    } }, { children: "Verify Code" })), _jsx(Button, Object.assign({ variant: "outlined", onClick: () => {
                        setCodeSending(true);
                        setCodeSendError("");
                        profile.resendCode(auth, {
                            okCallback: (clientDetailCode) => {
                                logger.log(LOGPREFIX + "resend-okCallback: " + clientDetailCode);
                                setCodeSending(false);
                                setCodeSendOk(true);
                                setTimeout(() => {
                                    setCodeSendOk(false);
                                }, 2500);
                            },
                            errorCallback: (clientDetailCode, errorMessage) => {
                                logger.log(LOGPREFIX +
                                    "resend-errorCallback: " +
                                    clientDetailCode +
                                    " " +
                                    errorMessage);
                                setCodeSending(false);
                                setCodeSendError(errorMessage + " (" + clientDetailCode + ")");
                            },
                        }, cacheBusterStore, logger);
                    } }, { children: "Resend Code" }))] })));
        if (profile && profile.profile && !((_b = profile.profile) === null || _b === void 0 ? void 0 : _b.emailVerified)) {
            cardsList.push(_jsx(ContentCard, { title: "Verify Email", text: "", keyStr: "verify.code.card", textColor: "#000000", backgroundColor: getTheme().palette.violet.contrastText, childComponent: verifyCardContent, actions: verifyCardActions }, "verify.code.card"));
        }
        // Profile Image Card
        const profileImageCardContent = (_jsxs(Stack, Object.assign({ spacing: 2, alignItems: "center", sx: { textAlign: "center", paddingBottom: "16px" } }, { children: [_jsx("img", { crossOrigin: "anonymous", src: previewImageUrl ||
                        authUrl(getContentURL() + "/u/" + auth.userId + "/profileImage_512.jpg", cacheBusterStore, auth), onError: (e) => {
                        const target = e.target;
                        target.src = "./img/profile_circle_640.png";
                    }, width: "200px", height: "200px", style: {
                        borderRadius: "50%",
                        objectFit: "cover",
                        border: "3px solid #ddd",
                    } }), _jsxs(Button, Object.assign({ variant: "contained", component: "label", disabled: imageSaving, sx: { marginBottom: "16px" } }, { children: [imageSaving ? "Uploading..." : "Set Profile Image", _jsx("input", { type: "file", accept: "image/jpeg,image/png", hidden: true, onChange: handleImageUpload })] })), imageSaving && (_jsx(LinearProgress, { sx: { width: "100%" } }, "profile-image-upload-progress")), imageSaveError && (_jsx(Typography, Object.assign({ variant: "body2", color: "error" }, { children: imageSaveError })))] })));
        cardsList.push(_jsx(ContentCard, { title: "Profile Image", text: "", keyStr: "profile.image.card", textColor: "#000000", backgroundColor: getTheme().palette.violet.contrastText, childComponent: profileImageCardContent }, "profile.image.card"));
        // Profile Name Card
        const displayNameCardContent = (_jsxs(Stack, Object.assign({ spacing: 1, alignItems: "center", sx: { textAlign: "center", paddingTop: "8px" } }, { children: [_jsx(TextField, { variant: "outlined", label: "Display Name", size: "small", sx: { width: "300px" }, value: displayNameModified ? displayName : (_c = profile === null || profile === void 0 ? void 0 : profile.profile) === null || _c === void 0 ? void 0 : _c.displayName, onChange: (event) => {
                        if (!displayNameModified) {
                            setDisplayNameModified(true);
                        }
                        setDisplayName(event.target.value);
                        setDisplayNameSaveError("");
                        setTimeout(() => {
                            validateUserNameAndUpdateHelpText(event.target.value);
                        }, 300);
                    }, error: !!displayNameHelperText, helperText: displayNameHelperText }), displayNameSaving && _jsx(LinearProgress, { sx: { width: "100%" } }), displayNameSavedOk && (_jsx(Card, Object.assign({ elevation: 0, sx: { backgroundColor: "#EEFFEE", padding: "4", width: "100%" }, color: "text.error" }, { children: _jsxs(CardContent, { children: [_jsx(Typography, Object.assign({ variant: "h6", component: "div", color: "EEFFEE", gutterBottom: true }, { children: "SAVED" })), _jsx(Typography, Object.assign({ variant: "body2", color: "black" }, { children: "Your changes have been saved." }))] }, "displayName.saved.ok.card.content") }), "displayName.saved.ok.card")), displayNameSaveError && (_jsx(Card, Object.assign({ elevation: 0, sx: { backgroundColor: "#FFEEEE", width: "100%" }, color: "text.error" }, { children: _jsxs(CardContent, { children: [_jsx(Typography, Object.assign({ variant: "h6", component: "div", color: "error", gutterBottom: true }, { children: "SAVE FAILED" })), _jsx(Typography, Object.assign({ variant: "body2" }, { children: displayNameSaveError }))] }, "displayName.saving.error.content") }), "displayName.saving.error"))] })));
        const displayNameCardActions = displayNameSaving ? undefined : (_jsx(CardActions, Object.assign({ sx: { display: "flex", justifyContent: "center" } }, { children: _jsx(Button, Object.assign({ variant: "contained", onClick: () => {
                    setDisplayNameSaving(true);
                    profile.saveProfile(auth, {
                        okCallback: (clientDetailCode) => {
                            logger.log(LOGPREFIX + "saveProfile-okCallback: " + clientDetailCode);
                            setDisplayNameSaving(false);
                            setDisplayNameSavedOk(true);
                            setTimeout(() => {
                                setDisplayNameSavedOk(false);
                            }, 2500);
                        },
                        errorCallback: (clientDetailCode, errorMessage) => {
                            logger.log(LOGPREFIX +
                                "saveProfile-errorCallback: " +
                                clientDetailCode +
                                " " +
                                errorMessage);
                            setDisplayNameSaving(false);
                            setDisplayNameSaveError(errorMessage + " (" + clientDetailCode + ")");
                        },
                    }, displayName, undefined, undefined, undefined, cacheBusterStore, logger);
                }, disabled: !!displayNameHelperText || !displayNameModified }, { children: "Save" })) })));
        cardsList.push(_jsx(ContentCard, { title: "Display Name", text: "", keyStr: "profile.name.card", textColor: "#000000", backgroundColor: getTheme().palette.violet.contrastText, childComponent: displayNameCardContent, actions: displayNameCardActions }, "profile.name.card"));
        // Contact Card
        const profileContactCardContent = (_jsxs(Stack, Object.assign({ spacing: 1, alignItems: "center", sx: { textAlign: "center", padding: "5px", marginTop: "-10px" } }, { children: [_jsx(Typography, Object.assign({ variant: "body2", color: "#999999" }, { children: "(private)" })), _jsx(TextField, { id: "emailField", variant: "outlined", label: "Email", size: "small", sx: { width: "300px" }, value: email1Modified ? email1 : (_d = profile === null || profile === void 0 ? void 0 : profile.profile) === null || _d === void 0 ? void 0 : _d.email, error: email1Modified ? !validateEmailNoUpdate(email1) : false, onChange: (event) => {
                        setEmailSaveError("");
                        if (!email2Modified) {
                            setEmail2("");
                            setEmail2Modified(true);
                        }
                        logger.log(LOGPREFIX + "Email Modified: " + event.target.value);
                        setEmail1Modified(true);
                        setEmail1(event.target.value);
                        setTimeout(() => {
                            validateEmailAndUpdateHelpText(event.target.value);
                        }, 300);
                    }, disabled: emailSaving, helperText: email1HelperText }), _jsx("br", {}), _jsx(TextField, { id: "emailField2", variant: "outlined", label: "Repeat Email", size: "small", sx: { width: "300px" }, value: email2Modified ? email2 : (_e = profile === null || profile === void 0 ? void 0 : profile.profile) === null || _e === void 0 ? void 0 : _e.email, onChange: (event) => {
                        setEmailSaveError("");
                        if (!email1Modified) {
                            setEmail1("");
                            setEmail1Modified(true);
                        }
                        setEmail2Modified(true);
                        setEmail2(event.target.value);
                    }, error: email2 !== email1, helperText: email2 !== email1 ? "Email addresses do not match." : "", disabled: emailSaving }), ((_f = profile === null || profile === void 0 ? void 0 : profile.profile) === null || _f === void 0 ? void 0 : _f.emailVerified) && !email1Modified && (_jsxs(Stack, Object.assign({ direction: "row" }, { children: [_jsx(CheckCircleIcon, { color: "success" }), _jsx(Typography, Object.assign({ variant: "body2", sx: { padding: "5px" } }, { children: "EMAIL VERIFIED" })), _jsx("br", {})] }))), emailSaving && _jsx(LinearProgress, { sx: { width: "100%" } }), emailSavedOk && (_jsx(Card, Object.assign({ elevation: 0, sx: { backgroundColor: "#EEFFEE", padding: "4", width: "100%" }, color: "text.error" }, { children: _jsxs(CardContent, { children: [_jsx(Typography, Object.assign({ variant: "h6", component: "div", color: "EEFFEE", gutterBottom: true }, { children: "SAVED" })), _jsx(Typography, Object.assign({ variant: "body2", color: "black" }, { children: "Your changes have been saved." }))] }, "email.saved.ok.card.content") }), "email.saved.ok.card")), emailSaveError && (_jsx(Card, Object.assign({ elevation: 0, sx: { backgroundColor: "#FFEEEE", width: "100%" }, color: "text.error" }, { children: _jsxs(CardContent, { children: [_jsx(Typography, Object.assign({ variant: "h6", component: "div", color: "error", gutterBottom: true }, { children: "SAVE FAILED" })), _jsx(Typography, Object.assign({ variant: "body2" }, { children: emailSaveError }))] }, "email.saving.error.content") }), "email.saving.error"))] })));
        const profileContactCardActions = emailSaving ? undefined : (_jsx(CardActions, Object.assign({ sx: { display: "flex", justifyContent: "center" } }, { children: _jsx(Button, Object.assign({ variant: "contained", disabled: !!email1HelperText || email2 !== email1 || !email1Modified, onClick: () => {
                    setEmailSaveError("");
                    setEmailSaving(true);
                    profile.saveProfile(auth, {
                        okCallback: (clientDetailCode) => {
                            logger.log(LOGPREFIX + "saveProfile-okCallback: " + clientDetailCode);
                            setEmailSaving(false);
                            setEmailSavedOk(true);
                            setEmail1Modified(false);
                            setEmail1(email1);
                            setEmail2Modified(false);
                            setEmail2(email1);
                            if (auth.userId) {
                                profile.loadProfile(auth.userId, auth, cacheBusterStore, logger);
                            }
                            setTimeout(() => {
                                setEmailSavedOk(false);
                            }, 2500);
                        },
                        errorCallback: (clientDetailCode, errorMessage) => {
                            logger.log(LOGPREFIX +
                                "saveProfile-errorCallback: " +
                                clientDetailCode +
                                " " +
                                errorMessage);
                            setEmailSaving(false);
                            setEmailSaveError(errorMessage + " (" + clientDetailCode + ")");
                        },
                    }, undefined, email1, undefined, undefined, cacheBusterStore, logger);
                } }, { children: "Save" })) })));
        cardsList.push(_jsx(ContentCard, { title: "Contact Info", text: "", keyStr: "profile.contactinfo.card", textColor: "#000000", backgroundColor: getTheme().palette.violet.contrastText, childComponent: profileContactCardContent, actions: profileContactCardActions }, "profile.contactinfo.card"));
        // Notifications Card
        const notificationsCardContent = (_jsxs(Stack, Object.assign({ spacing: 2, alignItems: "center", sx: { width: "100%", textAlign: "center" } }, { children: [_jsx(Typography, Object.assign({ variant: "body2", gutterBottom: true, sx: { textAlign: "center" } }, { children: "Manage your notification preferences" })), _jsx(FormControlLabel, { control: _jsx(Switch, { checked: emailNotifications, onChange: (event) => {
                            setEmailNotifications(event.target.checked);
                            setNotificationsModified(true);
                            setNotificationsSaveError("");
                        }, color: "primary" }), label: "Email Notifications", sx: {
                        width: "100%",
                        justifyContent: "center",
                        margin: 0,
                    } }), _jsx(Typography, Object.assign({ variant: "caption", color: "text.secondary", sx: { textAlign: "center" } }, { children: "Receive email notifications for important updates" })), notificationsSaving && _jsx(LinearProgress, { sx: { width: "100%" } }), notificationsSavedOk && (_jsx(Card, Object.assign({ elevation: 0, sx: { backgroundColor: "#EEFFEE", padding: "4", width: "100%" }, style: {
                        borderColor: getTheme().palette.violet.contrastText,
                    }, color: "text.error" }, { children: _jsxs(CardContent, { children: [_jsx(Typography, Object.assign({ variant: "h6", color: "black", sx: { textAlign: "center" }, gutterBottom: true }, { children: "SAVED" })), _jsx(Typography, Object.assign({ variant: "body2", color: "black" }, { children: "Your notification preferences have been saved." }))] }, "notifications.saved.ok.card.content") }), "notifications.saved.ok.card")), notificationsSaveError && (_jsx(Card, Object.assign({ elevation: 0, sx: { backgroundColor: "#FFEEEE", width: "100%" }, style: {
                        borderColor: getTheme().palette.violet.contrastText,
                    }, color: "text.error" }, { children: _jsxs(CardContent, { children: [_jsx(Typography, Object.assign({ variant: "h6", color: "black", sx: { textAlign: "center" }, gutterBottom: true }, { children: "SAVE FAILED" })), _jsx(Typography, Object.assign({ variant: "body2" }, { children: notificationsSaveError }))] }, "notifications.saving.error.content") }), "notifications.saving.error"))] })));
        const notificationsCardActions = notificationsSaving ? undefined : (_jsx(CardActions, Object.assign({ sx: { display: "flex", justifyContent: "center" } }, { children: _jsx(Button, Object.assign({ variant: "contained", onClick: () => {
                    saveNotifications();
                }, disabled: notificationsSaving || !notificationsModified }, { children: "Save" })) })));
        cardsList.push(_jsx(ContentCard, { title: "Notifications", text: "", keyStr: "profile.notifications.card", textColor: "#000000", backgroundColor: getTheme().palette.violet.contrastText, childComponent: notificationsCardContent, actions: notificationsCardActions }, "profile.notifications.card"));
        // Age Verification Status Card
        cardsList.push(_jsx(ContentCard, { title: "Age Verification", text: "", keyStr: "age.verification.card", textColor: "#000000", backgroundColor: getTheme().palette.violet.contrastText, childComponent: _jsx(AgeVerificationStatusCard, {}, "age.verification.subcard") }, "age.verification.card"));
        // Profile Account Info Card
        const profileInfoCardContent = (_jsxs(Stack, Object.assign({ spacing: 1, alignItems: "center", sx: { textAlign: "center" } }, { children: [_jsx(Typography, Object.assign({ variant: "caption" }, { children: "Account Name" })), _jsx(Typography, Object.assign({ variant: "body1", gutterBottom: true }, { children: auth === null || auth === void 0 ? void 0 : auth.userName })), _jsx("br", {}), _jsx(Typography, Object.assign({ variant: "caption" }, { children: "Account ID" })), _jsx(Typography, Object.assign({ variant: "body1", gutterBottom: true }, { children: auth === null || auth === void 0 ? void 0 : auth.userId })), _jsx("br", {})] })));
        if (feedData && auth.userId && ((_g = profile === null || profile === void 0 ? void 0 : profile.profile) === null || _g === void 0 ? void 0 : _g.displayName)) {
            cardsList.push(_jsx(FeedCardButton, { onClick: () => {
                    const displayName = auth === null || auth === void 0 ? void 0 : auth.displayName;
                    if (displayName) {
                        // Use the complete URL with proper localhost/production handling
                        const feedUrl = getChannelViewBaseURL() + encodeURIComponent(displayName);
                        window.location.href = feedUrl;
                    }
                    else {
                        navigate("/Feed"); // Fallback to redirect component
                    }
                }, feedTitle: feedData.title, feedDescription: feedData.description ? feedData.description : undefined, feedImageUrl: feedData.imageUrl
                    ? authUrl(feedData.imageUrl, cacheBusterStore, auth)
                    : undefined, displayName: (_h = profile === null || profile === void 0 ? void 0 : profile.profile) === null || _h === void 0 ? void 0 : _h.displayName, userId: auth.userId, auth: auth }, "feed.card.button"));
        }
        cardsList.push(_jsx(ContentCard, { title: "Account Info", text: "", keyStr: "profile.acctinfo.card", textColor: "#000000", backgroundColor: getTheme().palette.violet.contrastText, childComponent: profileInfoCardContent }, "profile.acctinfo.card"));
    }
    const deleteAccountActions = (_jsxs(CardActions, { children: [_jsx(Button, Object.assign({ variant: "outlined", color: "error", onClick: () => {
                    doDeleteAccount();
                } }, { children: "Yes" })), _jsx(Button, Object.assign({ variant: "contained", color: "error", onClick: () => {
                    setDeleteAccountClicked(false);
                } }, { children: "No" }))] }));
    const content = (_jsxs(Stack, Object.assign({ direction: "column" }, { children: [_jsx(TopButtonMenu, { current: "profile" }), loading && (_jsx(LinearProgress, { sx: { width: "100%", marginBottom: "10px", marginTop: "10px" } })), !deleteAccountClicked && (_jsx(ContentCardStacks, { keyStr: "profile.settings.cards", cards: cardsList })), !loading && !deleteAccountClicked && publicViewButton, !loading && !deleteAccountClicked && deleteAccountButton, !loading && !deleteAccountClicked && signOutButton, !loading && !deleteAccountClicked && manageConsentButton, !loading && !deleteAccountClicked && dsarButton, deleteAccountClicked && (_jsx(ContentCard, { title: "Delete Account", textColor: getTheme().palette.black.main, backgroundColor: "#FFEEEE", keyStr: "delete.account.card", maxWidth: 0.5, text: "WARNING: This will permanently delete all your account data. This cannot be undone. Are you sure you want to delete your account?", actions: deleteAccountActions }, "delete.account.card"))] })));
    const output = (_jsx("div", Object.assign({ style: { width: "100%", padding: 0, margin: 0 }, id: "outer" }, { children: _jsxs(ThemeProvider, Object.assign({ theme: getTheme() }, { children: [_jsx(Heading, {}), _jsx(Container, Object.assign({ sx: { backgroundColor: "#FFFFFF", width: "100%" } }, { children: content })), _jsx(Footer, {})] })) })));
    return output;
}
